<template>
    <b-row>
        <b-col cols="10">
            <b-form-input v-if="!gamestarted" v-model="form.playername"
                type="text"
                placeholder="Enter your name"></b-form-input>
        </b-col>
        <b-col cols="1">
            <b-button variant="primary" @click="addPlayer" v-if="!gamestarted">
              <font-awesome-icon v-if="!gamestarted" icon="plus"/>
            </b-button>
        </b-col>
    </b-row>
</template>

<script>
export default {
  name: 'AddPlayer',
   data () {
    return {
      form: {
       playername: '',
      },
    }
  },
  computed: {
      gamestarted() {
          return this.$store.getters.gameStarted
      },
  },
  methods: {
    addPlayer () {
      if (!this.form.playername) {
          alert('Bitte Spielernamen eingeben')
          return
      }
      this.$store.dispatch('newPlayer', {'name': this.form.playername})
      this.form.playername = ""
    },
  }
}
</script>